import { socketDisconnectFn } from '@/composables/socketEvents'

export default function () {
  const useCustomFetch = (api, opts) => {
    return useFetch(api, {
      method: opts.method,
      body: opts.body,
      onRequest: (res) => {
        onRequestBase(res)
        opts && opts.onRequest && opts.onRequest(res)
      },
      onRequestError: (resError) => {
        onRequestErrorBase(resError)
        opts && opts.onRequestError && opts.onRequestError(resError)
      },
      onResponse: (res) => {
        onResponseBase(res)
        opts && opts.onResponse && opts.onResponse(res)
      },
      onResponseError: (resError) => {
        onResponseErrorBase(resError)
        opts && opts.onResponseError && opts.onResponseError(resError)
      }
    })
  }

  // 設定請求時夾帶的標頭
  const onRequestBase = ({ request, response, options }) => {
    const token = localStorage.getItem('token')
    const tenantId = localStorage.getItem('tenantId')
    const Lang = localStorage.getItem('langs') || 'zh-TW'

    options.headers = options.headers || {}
    options.headers.token = token
    options.headers.Tenant = tenantId
    options.headers.Lang = Lang
    options.headers['Content-Type'] = 'application/json'
  }

  // 處理請求時發生的錯誤
  const onRequestErrorBase = ({ request, response, options }) => {
    const { $i18n } = useNuxtApp()

    if (!response.ok) {
      switch (response.status) {
        case 401:
          logout()
          alert($i18n.t('composables.fetchStatus401') + response.statusText)
          break
        case 403:
          alert($i18n.t('composables.fetchStatus403') + response.statusText)
          break
        case 404:
          alert($i18n.t('composables.fetchStatus404') + response.statusText)
          break
        case 500:
          alert($i18n.t('composables.fetchStatus500') + response.statusText)
          break
        case 504:
          alert($i18n.t('composables.fetchStatus504') + response.statusText)
          break
        default:
          alert('error' + response.statusText)
          break
      }
    }
  }

  // 處理請求回應的資料
  const onResponseBase = ({ request, response, options }) => {
    const res = response._data
    if (res.code) {
      switch (res.code) {
        case 200:
          return res.data
        default :
          ElMessage.error({ message: res.msg })
          break
      }
    }
  }

  // 處理請求回應發生的錯誤
  const onResponseErrorBase = ({ request, response, options }) => {
    const { $i18n } = useNuxtApp()

    if (!response.ok) {
      switch (response.status) {
        case 401:
          logout()
          alert($i18n.t('composables.fetchStatus401') + response.statusText)
          break
        case 403:
          alert($i18n.t('composables.fetchStatus403') + response.statusText)
          break
        case 404:
          alert($i18n.t('composables.fetchStatus404') + response.statusText)
          break
        case 500:
          alert($i18n.t('composables.fetchStatus500') + response.statusText)
          break
        case 504:
          alert($i18n.t('composables.fetchStatus504') + response.statusText)
          break
        default:
          alert('error' + response.statusText)
          break
      }
    }
  }

  // 處理登出
  const logout = () => {
    // 斷線 socket
    socketDisconnectFn()

    // 清空storage
    localStorage.removeItem('token')
    localStorage.removeItem('tenantId')
    localStorage.removeItem('convListConfig')
    localStorage.removeItem('currentPage')
    localStorage.removeItem('verifyId') // TODO 確認是否有需要存
    localStorage.removeItem('currentChannel') // TODO 確認是否有需要存
    localStorage.removeItem('sucRating') // 確認是否有需要存

    navigateTo('/login')
  }

  return {
    useCustomFetch
  }
}
